import { useContext } from 'react';

import { StableNavigateContext } from './stableNavigateContext';

export function useStableNavigate() {
  return useContext(StableNavigateContext);
}
